import React from 'react';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { IconLoader } from 'common/IconLoader';
import '../SoftwareDownloadModal.css';
import './DeviceVersionList.css';

export const DeviceVersionList = (props) => {
  let latestSwVersionId = props.allSwVersionList?.[0]?.sw_identifier;
  return (
    <div className="DeviceVersionList">
      <div>
        <span className={'DeviceVersionList_Version_Header'}>Select a version to install</span>
      </div>

      <div className="DeviceVersionList_TableDiv">
        {props.availableSwVersionList && props.availableSwVersionList.length > 0 ? (
          <PerfectScrollbar className="SoftwareDownloadModal_PS">
            <form>
              <table className="DeviceVersionList_Table">
                <tbody>
                  {props.availableSwVersionList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <RadioButton
                            /* checked={index === this.state.selectedIndex} */
                            isChecked={index === props.selectedIndex}
                            group={'deviceVersions'}
                            uniqueID={'deviceVersions' + index.toString()}
                            text={item.sw_version}
                            onChange={(event) => {
                              props.selectIndex(index);
                            }}
                          />
                        </td>
                        <td>
                          <div className="DeviceVersionList_Version_Notes">
                            <SvgAF
                              img={IconLoader.icon_note}
                              hover={IconLoader.icon_note_hover}
                              tooltip={'View release notes'}
                              onClick={() => {
                                console.log('Release Notes Icon Clicked!');
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          {item.sw_identifier === latestSwVersionId ? (
                            <div className={'DeviceVersionList_LatestVersion'}>(Latest Version)</div>
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </form>
          </PerfectScrollbar>
        ) : (
          <div className="DeviceVersionList_NoList">No available software version for this device</div>
        )}
      </div>
    </div>
  );
};
